import React from 'react';
import { connect } from 'react-redux';
import { Grid, Divider, Typography, withStyles, Button } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { Add } from '@material-ui/icons';
import { workIcon, workVerifierIcon, workDiagnoseIcon, workCheckIcon, mobileIcon, mobileVerifierIcon, mobileDiagnoseIcon, mobileCheckIcon, remoteIcon, moneyIcon, mobileErasureLiteIcon } from './utils';

const styles = theme => ({
    history: {
        width: '10rem',
        margin: theme.spacing(1),
    },
    grid: {
        padding: theme.spacing(2)
    },
    heading2: {
        fontSize: '120%',
        paddingLeft: theme.spacing(1),
    },
    divider: {
        width: 'auto',
        height: '1px'
    },
    heading3: {
        fontSize: '115%',
        fontWeight: 'bold',
        paddingLeft: theme.spacing(1),
    },
    icon: {
        position: "relative",
        top: "5px"
    },
});


const PrepaidBalanceList = props => {
    const { classes, translations, activeAccountID, findItem, redirectHandler, permissions, isTab } = props;

    const usageHistory = (type) => {
        return `/billing/accounts-overview?billingAccountID=${activeAccountID}&UsageType=${type}#4`;
    }

    const usageHistoryButton = (type) =>  hasPermission(permissions, 'billing_account_load') &&
    <Button color={'primary'} variant={'contained'} className={classes.history} onClick={(e) => { redirectHandler(usageHistory(type))}} >
        {translations["usage_history"] || 'Usage history'}
    </Button>

    return (
        <>
            {!isTab && BackButton(translations, classes.customTooltip)}
            {/*  ------For handling multiple accounts 
            <Grid container direction="row" alignItems="flex-start" spacing={1} className={classes.grid}>
                {accountID?.length > 1 ? dropdown : null}
            </Grid> */}

            <Grid container direction="row" alignItems="flex-start" className={classes.grid}>
                {hasPermission(permissions, 'topup_create') && hasPermission(permissions, 'topup_get_price_list') ? <Button color={'primary'} variant={'contained'} className={classes.topup} onClick={() => redirectHandler(`/topup/create?accountID=${activeAccountID}`)} >
                    <Add /> {translations["new_topup"] || 'New Topup'}
                </Button> : null}
            </Grid>

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{workIcon}</span> {translations["work_erasure"] || 'Work Erasure'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('work')? Math.floor(findItem('work')?.Credits || 0.00) : 0}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    {hasPermission(permissions, 'topup_list') ? <Button color={'primary'} variant={'contained'} className={classes.history} onClick={() => redirectHandler(`/topup/history?Unit=work&accountID=${activeAccountID}`)} >
                        {translations["topup_history"] || ' Topup History'}
                    </Button> : null}
                    {usageHistoryButton("work")}
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{workVerifierIcon}</span> {translations["work_erasure_verification"] || 'Work Erasure Verification'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('work_verifier')? Math.floor(findItem('work_verifier')?.Credits || 0.00) : 0}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    {hasPermission(permissions, 'topup_list') ? <Button color={'primary'} variant={'contained'} className={classes.history} onClick={() => redirectHandler(`/topup/history?Unit=work_verifier&accountID=${activeAccountID}`)} >
                        {translations["topup_history"] || ' Topup History'}
                    </Button> : null}
                    {usageHistoryButton("work_verifier")}
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{workDiagnoseIcon}</span> {translations["work_diagnose"] || 'Work Diagnose'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('work_diagnose')? Math.floor(findItem('work_diagnose')?.Credits || 0.00) : 0}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    {hasPermission(permissions, 'topup_list') ? <Button color={'primary'} variant={'contained'} className={classes.history} onClick={() => redirectHandler(`/topup/history?Unit=work_diagnose&accountID=${activeAccountID}`)} >
                        {translations["topup_history"] || ' Topup History'}
                    </Button> : null}
                    {usageHistoryButton("work_diagnose")}
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{workCheckIcon}</span> {translations["work_check"] || 'Work Check'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('work_check')? Math.floor(findItem('work_check')?.Credits || 0.00) : 0}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    {hasPermission(permissions, 'topup_list') ? <Button color={'primary'} variant={'contained'} className={classes.history} onClick={() => redirectHandler(`/topup/history?Unit=work_check&accountID=${activeAccountID}`)} >
                        {translations["topup_history"] || ' Topup History'}
                    </Button> : null}
                    {usageHistoryButton("work_check")}
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{mobileIcon}</span> {translations["mobile_erasure"] || 'Mobile Erasure'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('mobile')? Math.floor(findItem('mobile')?.Credits || 0.00) : 0}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    {hasPermission(permissions, 'topup_list') ? <Button color={'primary'} variant={'contained'} className={classes.history} onClick={() => redirectHandler(`/topup/history?Unit=mobile&accountID=${activeAccountID}`)} >
                        {translations["topup_history"] || ' Topup History'}
                    </Button> : null}
                    {usageHistoryButton("mobile")}
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{mobileErasureLiteIcon}</span> {translations["mobile_erasure_lite"] || 'Mobile Erasure Lite'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('mobile_erasure_lite')? Math.floor(findItem('mobile_erasure_lite')?.Credits || 0.00) : 0}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    {hasPermission(permissions, 'topup_list') ? <Button color={'primary'} variant={'contained'} className={classes.history} onClick={() => redirectHandler(`/topup/history?Unit=mobile_erasure_lite&accountID=${activeAccountID}`)} >
                        {translations["topup_history"] || ' Topup History'}
                    </Button> : null}
                    {usageHistoryButton("mobile_erasure_lite")}
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{mobileVerifierIcon}</span> {translations["mobile_erasure_verification"] || 'Mobile Erasure Verification'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('mobile_verifier')? Math.floor(findItem('mobile_verifier')?.Credits || 0.00) : 0}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    {hasPermission(permissions, 'topup_list') ? <Button color={'primary'} variant={'contained'} className={classes.history} onClick={() => redirectHandler(`/topup/history?Unit=mobile_verifier&accountID=${activeAccountID}`)} >
                        {translations["topup_history"] || ' Topup History'}
                    </Button> : null}
                    {usageHistoryButton("mobile_verifier")}
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{mobileDiagnoseIcon}</span> {translations["mobile_diagnose"] || 'Mobile Diagnose'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('mobile_diagnose')? Math.floor(findItem('mobile_diagnose')?.Credits || 0.00) : 0}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    {hasPermission(permissions, 'topup_list') ? <Button color={'primary'} variant={'contained'} className={classes.history} onClick={() => redirectHandler(`/topup/history?Unit=mobile_diagnose&accountID=${activeAccountID}`)} >
                        {translations["topup_history"] || ' Topup History'}
                    </Button> : null}
                    {usageHistoryButton("mobile_diagnose")}
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{mobileCheckIcon}</span> {translations["mobile_check"] || 'Mobile Check'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('mobile_check')? Math.floor(findItem('mobile_check')?.Credits || 0.00) : 0}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    {hasPermission(permissions, 'topup_list') ? <Button color={'primary'} variant={'contained'} className={classes.history} onClick={() => redirectHandler(`/topup/history?Unit=mobile_check&accountID=${activeAccountID}`)} >
                        {translations["topup_history"] || ' Topup History'}
                    </Button> : null}
                    {usageHistoryButton("mobile_check")}
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography variant='subtitle1' className={classes.heading2}><span className={classes.icon}>{remoteIcon}</span> {translations["remote"] || 'Remote'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('remote')? Math.floor(findItem('remote')?.Credits || 0.00) : 0}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    {hasPermission(permissions, 'topup_list') ? <Button color={'primary'} variant={'contained'} className={classes.history} onClick={() => redirectHandler(`/topup/history?Unit=remote&accountID=${activeAccountID}`)} >
                        {translations["topup_history"] || ' Topup History'}
                    </Button> : null}
                    {usageHistoryButton("remote")}
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{moneyIcon}</span> {translations["money"] || 'Money'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('currency')?.Credits || '0.00'}{' $'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    {hasPermission(permissions, 'topup_list') ? <Button color={'primary'} variant={'contained'} className={classes.history} onClick={() => redirectHandler(`/topup/history?Unit=currency&accountID=${activeAccountID}`)} >
                        {translations["topup_history"] || ' Topup History'}
                    </Button> : null}
                    {usageHistoryButton("currency")}
                </Grid>
            </Grid>
        </>);

};
const mapStateToProps = state => {
    return {
        translations: state?.translate?.translations?.activeTranslations || {},
        permissions: state?.core?.login?.permissions || [],
    };
};

export default connect(
    mapStateToProps,
    null)(withStyles(styles, { withTheme: true })(PrepaidBalanceList));
